import { AUTH_URL } from "../../urls.api";

export const LOGOUT_URL = `${AUTH_URL}/logout`;
